import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import Loadable from 'react-loadable';
import './App.scss';
import PrivateRoute from "./PrivateRoute";
import {useAuth0} from "./react-auth0-wrapper";
import Loading from "./views/Loading"

import "./App.css";

const loading = () => <div className="animated fadeIn pt-3 text-center">
  <div className="sk-spinner sk-spinner-pulse"></div>
</div>;

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading
});

// Pages
const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading
});

const Register = Loadable({
  loader: () => import('./views/Pages/Register'),
  loading
});

const InviteUserSignup = Loadable({
  loader: () => import('./views/Pages/InviteUserSignup'),
  loading
});

const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404'),
  loading
});

const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500'),
  loading
});

const Page403 = Loadable({
  loader: () => import('./views/Pages/Page403'),
  loading
})

const App = () => {
  const {loading} = useAuth0();

  if (loading) {
    return <Loading/>;
  }
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" name="Login Page" component={Login}/>
          <Route exact path="/register" name="Register Page" component={Register}/>
          <Route exact path="/invite-signup" name="Register Page" component={InviteUserSignup}/>
          <Route exact path="/404" name="Page 404" component={Page404}/>
          <Route exact path="/500" name="Page 500" component={Page500}/>
          <Route exact path="/403" name="Page 403" component={Page403}/>
          <PrivateRoute path="/" component={DefaultLayout}/>
        </Switch>
      </BrowserRouter>
    </div>
  )
}

export default App;
